/**
 * Shared staleness rule for applied template outputs.
 *
 * The Redux selector uses this with persisted template selections, while the export hook uses it
 * with a local confirmed selection before Redux hydration catches up.
 */
export function isAppliedTemplateFreshForSelection({
  appliedTemplateUserFileId,
  selectedTemplateUserFileId,
}: {
  appliedTemplateUserFileId: string | null | undefined
  selectedTemplateUserFileId: string | null | undefined
}): boolean {
  if (appliedTemplateUserFileId == null) return selectedTemplateUserFileId == null
  return selectedTemplateUserFileId === appliedTemplateUserFileId
}
